<template>
    <div>
      <b-form-group label-align="right" :label="$t('Vendor')" label-cols="4" label-cols-xl="4" label-cols-md="4">
        <b-form-input required type="number" v-model="newRadiusAttr.vendor"/>
      </b-form-group>
      <b-form-group label-align="right" :label="$t('Attribute')" label-cols="4" label-cols-xl="4" label-cols-md="4">
        <b-form-input required type="number" v-model="code"/>
        </b-form-group>
        <b-form-group  label-align="right" :label="$t('VSA tag')" label-cols="4" label-cols-xl="4" label-cols-md="4"
         v-if="isTaggedAttr && newRadiusAttr.vendor !== 0 && newRadiusAttr.vendor !== '' && newRadiusAttr.vendor !== '0'">
            <b-form-input required type="number" v-model="vsaTag"/>
        </b-form-group>
      <b-form-group label-align="right" :label="$t('Value')" label-cols="4" label-cols-xl="4" label-cols-md="4">
        <b-form-input required type="text" v-model="newRadiusAttr.value"/>
        <b-form-checkbox v-if="isTaggedAttr && Number(newRadiusAttr.vendor) === 0" v-model="isTunnel">{{ $t('Is value tunnel parameter?') }}</b-form-checkbox>
      </b-form-group>
      <b-form-group label-align="right" :label="$t('Type')" label-cols="4" label-cols-xl="4" label-cols-md="4">
        <b-form-radio-group v-model="newRadiusAttr.attr_type" name="radioType" :disabled="isTunnel">
          <b-form-radio :value=1>{{ $t('Number') }}</b-form-radio>
          <b-form-radio :value=2>{{ $t('String') }}</b-form-radio>
          <b-form-radio :value=3>{{ $t('IP') }}</b-form-radio>
          <b-form-radio :value=4>{{ $t('Binary') }}</b-form-radio>
        </b-form-radio-group>
      </b-form-group>
      <b-form-group label-align="right" :label="$t('Settings in services')" v-if="isISGprofile && !isCoARadiusAttrSIR" label-cols="4" label-cols-xl="4" label-cols-md="4">
        <b-form-group :label="$t('Service')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-select v-model="newRadiusAttr.properties[0].property_value" :options="services"/>
        </b-form-group>
        <b-form-group :label="$t('Event')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-select v-model="newRadiusAttr.properties[1].property_value" :options="accountState"/>
        </b-form-group>
      </b-form-group>
      <b-form-group label-align="right" :label="$t('SIR action')" v-if="isCoARadiusAttrSIR" label-cols="4" label-cols-xl="4" label-cols-md="4">
        <b-form-select  v-model="newRadiusAttr.object_type" :options="sirActionOptions"></b-form-select>
      </b-form-group>
      <b-form-group label-align="right" :label="$t('Use in')" v-if="!isISGprofile && !isCoARadiusAttrSIR" :disabled="isRadiusAccounts" label-cols="4" label-cols-xl="4" label-cols-md="4">
        <b-row>
          <b-col>
            <b-form-checkbox v-model="isAccessAccept" :disabled="isRemoveAttr">Access-accept</b-form-checkbox>
            <b-form-checkbox v-model="isDisconnectRequest" :disabled="isRemoveAttr">Disconnect-request</b-form-checkbox>
          </b-col>
          <b-col>
            <b-form-checkbox v-model="isCoaRequest" :disabled="isRemoveAttr">CoA-request</b-form-checkbox>
            <b-form-checkbox v-model="isAccessReject" :disabled="isRemoveAttr">Access-reject</b-form-checkbox>
          </b-col>
        </b-row>
      </b-form-group>
      <b-form-group label-align="right" :label="$t('Usage settings')" v-if="!isRadiusAccounts && !isCoARadiusAttrSIR" label-cols="4" label-cols-xl="4" label-cols-md="4">
        <b-row>
          <b-col>
            <b-form-checkbox v-model="isReplaceAttr" :disabled="isRemoveAttr">{{ $t('Replace attr.') }}</b-form-checkbox>
            <b-form-checkbox v-model="isRemoveAttr">{{ $t('Remove attr.') }}</b-form-checkbox>
          </b-col>
          <b-col>
            <b-form-checkbox v-model="isEnableScripting" :disabled="isRemoveAttr">{{ $t('Enable scripting') }}</b-form-checkbox>
            <b-form-checkbox v-model="isIfNotExists" :disabled="isRemoveAttr">{{ $t('Add if not exists') }}</b-form-checkbox>
          </b-col>
        </b-row>
      </b-form-group>
      <b-form-group label-align="right" :label="$t('Expire settings')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <flat-picker
            :isDisabled="!isActivate"
            @onDateChanged="(unixDate) => {newRadiusAttr.expire_date = unixDate}"
            @ready="(dp) => {dp.setDate($root.getMomentWithTZDelta(newRadiusAttr.expire_date ? newRadiusAttr.expire_date : moment(2000000000 * 1000).unix()).toDate())}"
          />
        <b-form-checkbox v-model="isActivate">{{ $t('Activate') }}</b-form-checkbox>
      </b-form-group>

      <modal-ok-cancel @save="saveRadiusAttr" @cancel="hideAddRadiusAttr" size="lg"/>
    </div>
</template>

<script>
import moment from 'moment'
export default {
  props: {
    isISGprofile: false,
    isRadiusAccounts: false,
    radiusAttrSIRItems: null,
    radiusAttrCoAItems: null,
    radiusAttrsCoASIRItems: null,
    radiusAttrItems: null,
    isRadiusAttrCoa: false,
    isRadiusAttrSIR: false,
    isCoARadiusAttrSIR: false,
    isEditRadiusAttr: null,
    rowRadiusAttr: null,
    radiusAttrItemsChanges: null,
    radiusAttrCoAItemsChanges: null,
    radiusAttrSIRItemsChanges: null,
    radiusAttrsCoASIRItemsChanges: null
  },
  data () {
    return {
      code: '',
      vsaTag: 0,
      isTaggedAttr: false,
      isActivate: false,
      sirActionOptions: [
        {value: 10, text: this.$i18n.t('On start')},
        {value: 11, text: this.$i18n.t('On end')}
      ],
      newRadiusAttr: {
        'value': '',
        'attr_type': 2,
        'attr_value': '',
        'code': 0,
        'expire_date': 0,
        'object_type': 10,
        'properties': [
          {'property_type': 1,
            'property_value': ''},
          {'property_type': 3,
            'property_value': ''}
        ],
        'tag': 0,
        'usage_flags': 0,
        'vendor': ''
      },
      radioTypeList: [
        { text: this.$i18n.t('String'), value: 2 },
        { text: this.$i18n.t('Number'), value: 1 },
        { text: 'IP', value: 3 },
        { text: this.$i18n.t('Binary'), value: 4 }
      ],
      flagAccessAccept: 1,
      flagAccessReject: 2,
      flagDisconnectRequest: 4,
      flagCoaRequest: 8,
      flagReplaceAttr: 16,
      flagEnableScripting: 32,
      flagRemoveAttr: 64,
      flagIsTunnel: 128,
      flagSetIfNotExists: 256,
      isAccessAccept: false,
      isAccessReject: false,
      isDisconnectRequest: false,
      isCoaRequest: false,
      isReplaceAttr: false,
      isEnableScripting: false,
      isRemoveAttr: false,
      isTunnel: false,
      isIfNotExists: false,
      originalRowRadius: null,
      notClickOnCancel: true
    }
  },
  methods: {
    load () {
      if (this.isEditRadiusAttr) {
        this.newRadiusAttr = this.rowRadiusAttr
        this.originalRowRadius = JSON.parse(JSON.stringify(this.rowRadiusAttr))

        this.code = this.newRadiusAttr.code
        if (this.newRadiusAttr.tag && (this.newRadiusAttr.vendor !== 0)) {
          this.vsaTag = this.newRadiusAttr.tag
        }
        if (this.rowRadiusAttr.properties.length >= 2) {
          this.newRadiusAttr.properties[0].property_value = this.rowRadiusAttr.properties[0].property_value
          this.newRadiusAttr.properties[1].property_value = this.rowRadiusAttr.properties[1].property_value
        }
        if (this.newRadiusAttr.expire_date !== 2000000000) this.isActivate = true
        if (this.newRadiusAttr.usage_flags) {
          if (this.newRadiusAttr.usage_flags & this.flagAccessAccept) this.isAccessAccept = true
          if (this.newRadiusAttr.usage_flags & this.flagAccessReject) this.isAccessReject = true
          if (this.newRadiusAttr.usage_flags & this.flagDisconnectRequest) this.isDisconnectRequest = true
          if (this.newRadiusAttr.usage_flags & this.flagCoaRequest) this.isCoaRequest = true
          if (this.newRadiusAttr.usage_flags & this.flagReplaceAttr) this.isReplaceAttr = true
          if (this.newRadiusAttr.usage_flags & this.flagEnableScripting) this.isEnableScripting = true
          if (this.newRadiusAttr.usage_flags & this.flagRemoveAttr) this.isRemoveAttr = true
          if (this.newRadiusAttr.usage_flags & this.flagIsTunnel) this.isTunnel = true
          if (this.newRadiusAttr.usage_flags & this.flagSetIfNotExists) this.isIfNotExists = true
        } else {
          this.isAccessAccept = false
          this.isIfNotExists = false
        }
      }
    },
    saveRadiusAttr () {
      if (isNaN(Number(this.newRadiusAttr.vendor))) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Invalid field vendor'), 'Error')
        return
      }
      if (this.newRadiusAttr.value === '') {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Invalid field value'), 'Error')
        return
      }
      if (!this.code) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Invalid field attribute'), 'Error')
        return
      }
      if (this.newRadiusAttr.attr_type === 3 && !this.isTunnel) {
        if (!this.validationIP()) return
      }
      if (this.newRadiusAttr.attr_type === 1 && !this.isTunnel) {
        if (!this.validationNum()) return
      }
      if (this.newRadiusAttr.attr_type === 4 && !this.isTunnel) {
        if (!this.validationBinary()) return
      }
      if (this.isTunnel && this.tunnelTypes.includes(Number(this.code))) {
        if (!this.validationTunnel()) return
      }

      switch (this.newRadiusAttr.attr_type) {
        case 1:
          this.newRadiusAttr.attrType = this.$i18n.t('Number')
          break
        case 2:
          this.newRadiusAttr.attrType = this.$i18n.t('String')
          break
        case 3:
          this.newRadiusAttr.attrType = 'IP'
          break
        case 4:
          this.newRadiusAttr.attrType = this.$i18n.t('Binary')
          break
      }
      this.newRadiusAttr.usage_flags = 0
      this.newRadiusAttr.usage_flags += this.isAccessAccept ? this.flagAccessAccept : 0
      this.newRadiusAttr.usage_flags += this.isAccessReject ? this.flagAccessReject : 0
      this.newRadiusAttr.usage_flags += this.isDisconnectRequest ? this.flagDisconnectRequest : 0
      this.newRadiusAttr.usage_flags += this.isCoaRequest ? this.flagCoaRequest : 0
      this.newRadiusAttr.usage_flags += this.isReplaceAttr ? this.flagReplaceAttr : 0
      this.newRadiusAttr.usage_flags += this.isEnableScripting ? this.flagEnableScripting : 0
      this.newRadiusAttr.usage_flags += this.isRemoveAttr ? this.flagRemoveAttr : 0
      this.newRadiusAttr.usage_flags += this.isTunnel ? this.flagIsTunnel : 0
      this.newRadiusAttr.usage_flags += this.isIfNotExists ? this.flagSetIfNotExists : 0
      if (this.isISGprofile) {
        for (let el of this.services) {
          if (el.value === this.newRadiusAttr.properties[0].property_value) {
            this.newRadiusAttr.service = el.text
          }
        }
      }
      if (this.isRadiusAttrCoa) {
        this.newRadiusAttr.usage_flags += this.flagDisconnectRequest
        this.newRadiusAttr.usage_flags += this.flagCoaRequest
        for (let el of this.accountState) {
          if (el.value === this.newRadiusAttr.properties[1].property_value) {
            this.newRadiusAttr.event = el.text
          }
        }
      }
      if (this.isTunnel) {
        this.newRadiusAttr.tag = Number(this.newRadiusAttr.value.split(':')[1])
        this.newRadiusAttr.attr_value = this.newRadiusAttr.value.split(':')[2]
      } else {
        this.newRadiusAttr.attr_value = this.newRadiusAttr.value
      }
      this.newRadiusAttr.tag = this.vsaTag !== 0 ? this.vsaTag : this.newRadiusAttr.tag
      this.newRadiusAttr.tag = this.newRadiusAttr.tag !== 0 ? Number(this.newRadiusAttr.tag) : this.newRadiusAttr.tag

      this.newRadiusAttr.code = Number(this.code)
      this.newRadiusAttr.vendor = Number(this.newRadiusAttr.vendor)
      if (this.isActivate) {
        if (!this.validateExpireDate(this.newRadiusAttr.expire_date)) return
      } else {
        this.newRadiusAttr.expire_date = 2000000000
      }
      if (this.newRadiusAttr.attr_type === 1) {
        this.newRadiusAttr.attr_value = Number(this.newRadiusAttr.attr_value)
      }

      if (this.isEditRadiusAttr) {
        this.$emit('edited', this.newRadiusAttr)
      }

      if (this.isCoARadiusAttrSIR) {
        if (this.radiusAttrsCoASIRItemsChanges && !this.isEditRadiusAttr) this.radiusAttrsCoASIRItemsChanges.add.push(this.newRadiusAttr)
        if (this.isEditRadiusAttr) {
          if (this.newRadiusAttr.object_type === 10) this.$emit('editedCoASIRonRun', this.newRadiusAttr)
          if (this.newRadiusAttr.object_type === 11) this.$emit('editedCoASIRonClose', this.newRadiusAttr)
        } else {
          this.radiusAttrsCoASIRItems.push(this.newRadiusAttr)
          this.radiusAttrsCoASIRItems.sort((lhs, rhs) => lhs.object_type > rhs.object_type)
        }
        this.hideAddRadiusAttr()
        return
      }

      if (this.isRadiusAttrSIR) {
        if (this.radiusAttrSIRItemsChanges && !this.isEditRadiusAttr) this.radiusAttrSIRItemsChanges.add.push(this.newRadiusAttr)
        if (this.isEditRadiusAttr) {
          this.$emit('editedSIR', this.newRadiusAttr)
        } else {
          this.radiusAttrSIRItems.push(this.newRadiusAttr)
        }
        this.hideAddRadiusAttr()
        return
      }

      if (this.isRadiusAttrCoa) {
        if (this.radiusAttrCoAItemsChanges && !this.isEditRadiusAttr) this.radiusAttrCoAItemsChanges.add.push(this.newRadiusAttr)
        if (this.isEditRadiusAttr) {
          this.$emit('editedCoa', this.newRadiusAttr)
        } else {
          this.radiusAttrCoAItems.push(this.newRadiusAttr)
        }
        this.hideAddRadiusAttr()
        return
      }
      if (!this.isRadiusAttrCoa && !this.isRadiusAttrSIR) {
        if (this.radiusAttrItemsChanges && !this.isEditRadiusAttr) this.radiusAttrItemsChanges.add.push(this.newRadiusAttr)
        if (this.isEditRadiusAttr) {
          this.$emit('editedISGAttr', this.newRadiusAttr)
        } else {
          this.radiusAttrItems.push(this.newRadiusAttr)
        }
        this.hideAddRadiusAttr()
      }
    },
    validateExpireDate (date) {
      if (date < this.$root.getMomentWithTZDelta(moment().unix()).unix()) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('It is forbidden to set data with expiry date earlier than the current one'), 'Error')
        return false
      }
      return true
    },
    validateExpire (items) {
      if (!items) return
      for (let attr of items) {
        if (typeof attr.expire_date === 'string') {
          attr.expire_date = attr.expire_date === moment(2000000000 * 1000).unix() ? 2000000000 : Number(Date.parse(attr.expire_date)) / 1000
        }
      }
    },
    hideAddRadiusAttr () {
      this.notClickOnCancel = false
      this.$emit('hideAddRadiusAttr')
    },
    validationIP () {
      let goodChars = '^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$'
      if (this.newRadiusAttr.value.match(goodChars)) {
        return true
      } else {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Incorrect IP format'), 'Error')
        return false
      }
    },
    validationNum () {
      if (Number(this.newRadiusAttr.value)) {
        return true
      } else {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Value field is invalid'), 'Error')
        return false
      }
    },
    validationBinary () {
      let goodChars = '^[0-9a-fA-F]+$'
      if (this.newRadiusAttr.value.length % 2 === 0 && this.newRadiusAttr.value.match(goodChars)) {
        return true
      } else {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Incorrect binary format'), 'Error')
        return false
      }
    },
    validationTunnel () {
      let goodChars = '^:(\\d*):(\\w*)'
      let arrValidation = this.newRadiusAttr.value.match(goodChars)
      if (arrValidation && arrValidation[1] < 32) {
        return true
      } else {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Incorrect tunnel format'), 'Error')
        return false
      }
    }
  },
  beforeMount () {
    this.load()
    this.$store.dispatch('Settings/GET_TUNNEL_ATTRIBUTES')
    if (!this.isRadiusAttrCoa) {
      for (let el of this.newRadiusAttr.properties) {
        if (el.property_type === 3) {
          el.property_type = 2
          break
        }
      }
    }
    if (!isNaN(this.radiusAttrsCoASIRItems)) {
      this.newRadiusAttr.object_type = 10
    }
  },
  watch: {
    code: function (val) {
      this.tunnelTypes.forEach(element => {
        if (Number(element.vendor_id) === Number(this.newRadiusAttr.vendor) &&
        Number(element.attr_type) === Number(val)) {
          this.isTaggedAttr = true
        }
      })
    }
  },
  computed: {
    tunnelTypes () {
      return this.$store.getters['Settings/TUNNEL_ATTRIBUTES']
    },
    services () {
      if (this.isISGprofile) {
        let res = this.$store.getters['Tariffing/SERVICES']
        let services = []
        let newEl = {
          value: '',
          text: this.$i18n.t('All services')
        }
        services.push(newEl)
        for (let el of res) {
          let isType = false
          let newEl = {
            value: '0',
            text: ''
          }
          switch (el.service_type) {
            case 3:
              isType = true
              break
            case 4:
              isType = true
              break
            case 5:
              isType = true
              break
            case 6:
              isType = true
              break
          }
          if (isType) {
            newEl.value = String(el.service_id)
            newEl.text = el.service_name + '(' + el.service_id + ')'
            services.push(newEl)
          }
        }
        return services
      } else {
        return []
      }
    },
    accountState () {
      if (this.isRadiusAttrCoa) {
        return [{ text: this.$i18n.t('Blocked'), value: '1' },
          { text: this.$i18n.t('Unbloked'), value: '0' },
          { text: this.$i18n.t('Delete slink'), value: '2' },
          { text: this.$i18n.t('Tariff changing'), value: '3' },
          { text: this.$i18n.t('All states'), value: '' }]
      } else {
        return [{ text: this.$i18n.t('Blocked'), value: '1' },
          { text: this.$i18n.t('Unbloked'), value: '0' },
          { text: this.$i18n.t('All states'), value: '' }]
      }
    }

  },
  beforeDestroy () {
    this.validateExpire(this.radiusAttrItems)
    this.validateExpire(this.radiusAttrSIRItems)
    this.validateExpire(this.radiusAttrItems)
    if (this.notClickOnCancel) {
      this.$emit('restoreISGAttr', this.originalRowRadius)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/tariffication/servicesAndTariffs/formRadiusAttributs.vue